var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserMagnifyingGlass = function SvgUserMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 3.6a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2m0 8.4a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6m-5.115 3h7.545a6 6 0 0 1-.03-.6q0-.302.03-.6H2.4L.368 20.4 0 21.6h16.8l-.367-1.2H1.624zM16.8 10.804a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2m0 8.4c1.11 0 2.13-.375 2.944-1.009l2.932 2.918.424.423.848-.85-.424-.425-2.929-2.913a4.8 4.8 0 1 0-3.795 1.86z"
  })));
};
export default SvgUserMagnifyingGlass;